import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const composeEmailActions = createActions(
  {
    COMPOSE_EMAIL_FIND_USER: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    COMPOSE_EMAIL_GET_ALL_FROM: [
      (payload: any) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'COMPOSE_EMAIL_FIND_USER_SUCCEEDED',
  'COMPOSE_EMAIL_FIND_USER_FAILED',

  'COMPOSE_EMAIL_GET_ALL_FROM_SUCCEEDED',
  'COMPOSE_EMAIL_GET_ALL_FROM_FAILED',
);
